import {
  updateMultipleComments,
  getInstanceComments,
  updateMultipleIMIComments,
  getInstanceIMIComments,
  updateMultiplePreTrialComments,
  getInstancePreTrialComments,
} from '../../actions';

export const commentCollectionsConfig = {
  comments: {
    fetchComments: getInstanceComments,
    updateComments: updateMultipleComments,
    color: '#013BB1',
    internalCycles:['dev_alpha_internal', 'dev_beta_internal', 'dev_final_internal'],
    redirect: 'pages',
    displayName: 'Storyboard Comments',
  },
  imi_comments: {
    fetchComments: getInstanceIMIComments,
    updateComments: updateMultipleIMIComments,
    color: '#481FA7',
    internalCycles: ['prod_alpha_internal', 'prod_beta_internal', 'prod_final_internal'],
    redirect: 'imi-comments/pages',
    displayName: 'IMI Comments',
  },
  pre_trial_comments: {
    fetchComments: getInstancePreTrialComments,
    updateComments: updateMultiplePreTrialComments,
    color: '#FF5454',
    internalCycles: ['trials_pre'],
    redirect: 'pre-trial-comments/pages',
    displayName: 'Pre-Trial Comments',
  },
};